import React, { useEffect, useState } from "react";
import {
    Card,
    CardContent,
    Typography,
    CircularProgress,
    Button,
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { baseUrl, get, remove } from "../../../services/api-services";
import { useParams } from "react-router-dom";
import AddImageDialog from "../profileModel-DialogBox/AddImageLibrary";
import { formatToMonthYear } from "../../../modules/ConvertDate";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';
import { useCommon } from "../../../context/CommonContext";
import DeleteDialog from "../../../dialogs/DeleteDialog";
const UserImageLibrary = ({ userId, event }) => {
    const [userGallery, setUserGallery] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isAddImageDialogOpen, setIsAddImageDialogOpen] = useState(false);
    const [isViewImageDialogOpen, setIsViewImageDialogOpen] = useState(false);
    const [filterDate, setFilterDate] = useState("");
    const [dialogData, setDialogData] = useState(null);
    const { id } = useParams();
    const [imgCount, setImgCount] = useState(0);
    const { setSnackbar } = useCommon();
    const [openDelete, setOpenDelete] = useState(false);

    const onDeleteImage = async () => {
        const image = dialogData.imageUrl.split('/');
        const res = await remove(`/Uploads/gallery/files/${image[image?.length - 1]}`);
        const delRes = await remove(`/Galleries/${dialogData?.imgId}`)
        if (res?.statusCode === 200 && delRes?.statusCode === 200) {
            fetchUserImageLibrary();
            setSnackbar({
                openSnackbar: true,
                message: 'Picture deleted successfully',
                severity: 'success'
            });
            setOpenDelete(false);
            setIsViewImageDialogOpen(false);
        }
    }
    const handleDownload = async () => {
        try {
            const response = await fetch(dialogData.imageUrl);
            if (!response.ok) {
                throw new Error(`Failed to fetch image: ${response.statusText}`);
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "downloaded_image.jpg";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };

    const fetchUserImageLibrary = React.useCallback(async () => {
        try {
            const cURL = `/Galleries/count?where=${encodeURIComponent(`{"customerId":"${id}"}`)}`;
            const countResponse = await get(cURL);
            if (countResponse?.statusCode === 200) {
                setImgCount(countResponse?.data?.count)
            } else {
                console.error("Error fetching count:", countResponse?.statusCode);
            }
            const url = filterDate ? `/Galleries?filter={"where":{"customerId":"${id}","uploadedDate":"${filterDate}"}}` : `/Galleries?filter={"where":{"customerId":"${id}"}}`;
            const response = await get(url);
            const data = response?.data;
            const groupedData = data?.reduce((acc, { uploadedDate, image, ...rest }) => {
                const dateObj = new Date(uploadedDate);
                const yearMonth = `${dateObj.getFullYear()}-${dateObj.getMonth() + 1}`;
                const existingGroup = acc.find(group => group.date === yearMonth);
                if (existingGroup) {
                    existingGroup.image.push({ url: image, ...rest, uploadedDate: uploadedDate });
                } else {
                    acc.push({
                        date: yearMonth,
                        image: [{ url: image, uploadedDate: uploadedDate, ...rest }]
                    });
                }
                return acc;
            }, []);
            groupedData.sort((a, b) => {
                return b.date.localeCompare(a.date);
            });
            setUserGallery(groupedData);
        } catch (error) {
            console.error("Error fetching user gallery:", error);
            setSnackbar({
                openSnackbar: true,
                message: 'Error fetching gallery. Please try again.',
                severity: 'error'
            })
        } finally {
            setLoading(false);
        }
    }, [id, filterDate, setSnackbar]);

    // Fetch Image Details
    const viewLibraryPicDialog = async (data) => {
        try {
            setDialogData({
                imgId: data?.id,
                imageUrl: `${baseUrl}/Uploads/gallery/download/${data?.url}`,
                uploadedDate: data?.uploadedDate,
                uploadBy: data?.uploadBy,
            });
            setIsViewImageDialogOpen(true);
        } catch (error) {
            console.error("Error fetching image details:", error);
            setSnackbar({
                openSnackbar: true,
                message: 'Error fetching image details. Please try again.',
                severity: 'error'
            })
        }
    };
    useEffect(() => {
        fetchUserImageLibrary();
    }, [fetchUserImageLibrary, userId, event]);

    return (
        <div className="flex-1 flex flex-col min-h-96 xl:min-h-0">
            <Card className="relative flex-1 flex flex-col" sx={{ minHeight: '220px' }}>
                <CardContent className="flex-1 flex flex-col" sx={{ pb: 8 }}>
                    {!loading && <Box display='flex' justifyContent='space-between'>
                        <Typography variant="h5" fontWeight={'bold'} >
                            {`${imgCount} Pictures`}
                        </Typography>
                        <TextField type="date" size="small" variant="standard" value={filterDate} onChange={(e) => setFilterDate(e.target.value)} />
                    </Box>}
                    {loading
                        ?
                        <Box display='flex' justifyContent="center" alignItems="center" flex={1}>
                            <CircularProgress />
                        </Box>
                        : userGallery?.length > 0
                            ? <Box display='flex' flexDirection='column' gap={5}>
                                {userGallery?.map((galary, index) => (
                                    <div key={index} >
                                        <Typography variant="body2" gutterBottom marginBottom={2}>
                                            {formatToMonthYear(galary.date)}
                                        </Typography>
                                        <Box display='flex' gap={5}>
                                            {galary?.image?.map((image, index) => (
                                                <Card
                                                    key={index}
                                                    onClick={() => viewLibraryPicDialog(image)}

                                                    className="w-44 h-44 overflow-hidden rounded-md flex flex-wrap"
                                                >
                                                    <img
                                                        src={`${baseUrl}/Uploads/gallery/download/${image.url}`}
                                                        alt="galary"
                                                        style={{
                                                            width: "100%",
                                                            height: "100%",
                                                            borderRadius: "inherit",
                                                        }}
                                                    />
                                                </Card>
                                            ))}
                                        </Box>
                                    </div>
                                ))}
                            </Box>
                            : <Typography className="flex-1 flex justify-center items-center">Add Pictures....</Typography>
                    }
                </CardContent>
                <Box sx={{ position: "absolute", bottom: 16, right: 16 }}>
                    <Button
                        sx={{
                            borderRadius: "50%",
                            height: 60,
                            width: 60,
                            backgroundColor: "secondary.main",
                        }}
                        variant="contained"
                        onClick={() => setIsAddImageDialogOpen(true)}
                    >
                        <AddIcon sx={{ fontSize: 30 }} />
                    </Button>
                </Box>
            </Card>
            {/* Add Picture Dialog */}
            <AddImageDialog open={isAddImageDialogOpen} onClose={() => setIsAddImageDialogOpen(false)} fieldType="multiple" customerId={id} getGalary={fetchUserImageLibrary} />

            {/* View Image Dialog */}
            {dialogData && (
                <Dialog open={isViewImageDialogOpen} fullWidth onClose={() => setIsViewImageDialogOpen(false)}>
                    <DialogTitle>{formatToMonthYear(dialogData?.uploadedDate)}</DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={() => setIsViewImageDialogOpen(false)}
                        size="small"
                        sx={(theme) => ({
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: theme.palette.grey[500],
                        })}
                    >
                        <CloseIcon />
                    </IconButton>
                    <DialogContent className="flex justify-center">
                        <img src={dialogData.imageUrl} alt="View" />
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: "start" }}>
                        <DownloadIcon color="success" className="cursor-pointer" onClick={handleDownload} />
                        <DeleteIcon color="error" className="cursor-pointer" onClick={() => setOpenDelete(true)} />
                    </DialogActions>
                </Dialog>
            )}
            <DeleteDialog open={openDelete} setOpen={setOpenDelete} onSubmit={onDeleteImage} name='Picture' />
        </div>
    );
};

export default UserImageLibrary;